import { Form, Button, Input, Icon, Radio, Modal, Select } from 'antd';
import { Row, Col } from 'yxyweb/common/components/basic';
import React, { Component } from 'react';
// import * as common from 'yxyweb/client/common/common'
import * as BasicComponents from '../basic';
import { fail } from 'assert';
import * as  eChartProxy from '../echart/eChartProxy';
import SvgIcon from 'SvgIcon';

const Tag2 = BasicComponents.Tag2;

const BasicComponentsMap = {};
for (var attr in BasicComponents)
  BasicComponentsMap[attr.toLocaleLowerCase()] = BasicComponents[attr];
export default class batchModify extends Component {
  constructor(props) {
    super(props);
    this.model = props.model;
    this.billType = props.billType;
    if (this.isTest()) {
      this.billType = "voucher";
    }
    this.billNo = props.billNo;
    this.params = props.params;
    // let modelParams = this.model.getParams();
    // let filterId = modelParams.filterId;
    this.gridModel = this.getGridModel()
    this.state = this.getInitState(props);
  }

  getInitState(props) {
    let tmp = {};
    tmp.UEType = 0;// 修改项的类型 1 数值类型  2 字符串类型  3 参照或者枚举类型 4 参照
    tmp.fieldInfoArr = [];//可以字段信息
    // tmp.mFieldValue = "";
    tmp.modifyFieldName = "";//修改项
    tmp.modifyOperator = "=";
    tmp.filterRange = 0;//修改选中还是全部记录
    if (this.billType == "voucher")
      tmp.filterRange = 1;
    tmp.filterObjs = [];//显示在界面上的过滤条件对象
    tmp.filterOperatorsArr = [
      { code: "dengyu", name: "等于", valueCount: 1 },
      { code: "budengyu", name: "不等于", valueCount: 1 },
      { code: "xiaoyu", name: "小于", valueCount: 1 },
      { code: "xiaoyudengyu", name: "小于等于", valueCount: 1 },
      { code: "dayu", name: "大于", valueCount: 1 },
      { code: "dayudengyu", name: "大于等于", valueCount: 1 },
      { code: "qujian", name: "区间", valueCount: 2, middleText: "至" },
      { code: "baohan", name: "包含", valueCount: 1 },
      { code: "bubaohan", name: "不包含", valueCount: 1 },
      { code: "baohanyu", name: "包含于", valueCount: 1 },
      { code: "bubaohanyu", name: "不包含于", valueCount: 1 }
    ];//过滤比较符集合
    tmp.gridDataRows = [];
    return tmp;
  }
  isTest() {
    return false;
  }

  getModifiedArr() {
    let obj = this.containerModel && this.containerModel.getDirtyData(false);
    this.consoleLog("修改后ContainerModel中的脏数据字段 ： " + JSON.stringify(obj))
    this.clearNullObj(obj);
    return obj;
  }
  validateInput(obj) {
    // tmp.UEType = 0;// 修改项的类型 1 数值类型  2 字符串类型  3 参照或者枚举类型 4 参照
    // tmp.fieldInfoArr = [];//可以字段信息
    // // tmp.mFieldValue = "";
    // tmp.modifyFieldName = "";//修改项
    // tmp.modifyOperator = "=";
    // tmp.filterRange = 0;//修改选中还是全部记录
    // tmp.filterObjs = [];//显示在界面上的过滤条件对象
    let self = this;
    let UEType = this.state.UEType;
    let modifyFieldName = this.state.modifyFieldName;
    // let obj = this.getModifiedArr();
    let modifyFieldValue = obj && obj[modifyFieldName];
    let modifyOperator = this.state.modifyOperator;
    let filterRange = this.state.filterRange;
    let filterObjs = this.state.filterObjs;
    let billType = this.billType;
    let gridModel = this.gridModel;
    let errMsg = "";
    if (self.isEmptyValue(obj)) {
      errMsg = "请输入修改数据信息。";
    }
    if (self.isEmptyValue(modifyFieldName)) {
      errMsg = "请选择更改字段";
    }
    if (filterRange == 1 && gridModel.getRows().length < 1) {
      errMsg = "没有可以更改的记录";
    }
    if (billType == "list" && filterRange == 0 && gridModel.getSelectedRows().length < 1) {
      errMsg = "请选择记录";
    }
    if (billType == "voucher" && filterRange == 0) {
      if (filterObjs.length == 0) {
        errMsg = "请增加过滤条件。";
      }
      else if (_.filter(filterObjs, function (o) { return self.isEmptyValue(o.fieldName) || self.isEmptyValue(o.operator) }).length > 0) {
        errMsg = "存在过滤字段或者操作符为空的过滤行，请检查";
      }
    }

    //检查修改的值正确性
    if (UEType == 1) {
      if (self.isEmptyValue(modifyOperator)) {
        errMsg = "操作符不可为空，请检查";
      }
      else if (modifyOperator == "+" || modifyOperator == "-" || modifyOperator == "*" || modifyOperator == "/") {
        if (self.isEmptyValue(modifyFieldValue)) {
          errMsg = "数值不可为空，请检查";
        }
        else if (isNaN(modifyFieldValue)) {
          errMsg = "请录入正确的数值";
        }
      }
    }
    if (_.isEmpty(this.clearNullObj(obj))) {
      errMsg = "请修改字段信息。";
    }
    if (errMsg == "") {
      return true;
    }
    else {
      cb.utils.alert(errMsg, 'warning');
      return false;
    }

  }
  getGridModel() {
    let self = this;
    let tmp;
    let model = this.model;
    if (this.isList() == true) {
      tmp = model && model.getGridModel();
    }
    if (this.isVoucher() == true) {
      if (this.params && this.params['childrenField']) {
        tmp = model.get(this.params['childrenField']);
      }
      else if (this.billNo == "pc_product" && model.get("productParams")) {
        tmp = model.get("productParams");
      }
      else if (this.billNo == "aa_vendor" && model.get("vendorbanks")) {
        tmp = model.get("vendorbanks");
      }
      else {
        tmp = model.getGridModel();
      }
    }
    if (!tmp) {
      this.consoleLog("批改错误：初始化 batchModify 没有找到GridModel!", true);
    }
    return tmp;
  }
  componentDidMount() {
    this.initDataByGrid();
  }

  getFilterShowContent() {
    let self = this;
    let filterObjs = this.state.filterObjs;
    if (filterObjs.length < 1) {
      filterObjs.push(this.getNullFilterObj());
    }
    let filterFieldsOption = [];
    this.state.fieldInfoArr.forEach((ele, index) => {
      if (ele.bCanFilter == true) {
        filterFieldsOption.push(<Select.Option key={ele.fieldName} text={ele.fieldCaption}>{ele.fieldCaption}</Select.Option>);
      }
    });

    let filterOperatorsOption = [];
    this.state.filterOperatorsArr.forEach((ele, index) => {
      filterOperatorsOption.push(<Select.Option key={ele.code} text={ele.name} valueCount={ele.valueCount} >{ele.name}</Select.Option>);
    });
    let contentArr = [];
    filterObjs.forEach((ele, index) => {
      let rowContent = [];
      rowContent.push(<span className="BatchModify-FieldName">
        <Select value={ele.fieldName}
          onChange={(value) => this.editFilterShowField("fieldName", index, value)}>
          {filterFieldsOption}
        </Select>
      </span>);

      rowContent.push(<span className="BatchModify-Operator" >
        <Select value={ele.operator}
          onChange={(value) => this.editFilterShowField("operator", index, value)}>
          {filterOperatorsOption}
        </Select>
      </span>);

      let operatorEle = ele.operator && _.find(self.state.filterOperatorsArr, function (o) { return o.code == ele.operator });
      let inputClassName = "BatchModify-InputNum-" + (operatorEle ? operatorEle.valueCount : "1");
      if (ele.operator == "baohan") {
        rowContent.push(<span className={inputClassName} >
          <Input
            placeholder="请输入"
            value={ele.value1}
            onChange={(e) => this.editFilterShowField("value1", index, e.target.value)}
          />
        </span>);
      }
      else if (ele.operator == "baohanyu" || ele.operator == "bubaohanyu") {
        rowContent.push(<span className={inputClassName} >
          <Select
            value={ele.value1 || undefined}
            onChange={(value) => this.editFilterShowField("value1", index, value)}
            allowClear
            placeholder="请输入"
            mode="multiple"
          // mode="tags"
          >
            {this.getValueOption(ele.fieldName)}
          </Select>
        </span>);
      }
      else {
        rowContent.push(<span className={inputClassName}  >
          <Select
            value={ele.value1}
            onChange={(value) => this.editFilterShowField("value1", index, value)}
            allowClear
            placeholder="请输入"
          // mode="tags"
          >
            {this.getValueOption(ele.fieldName)}
          </Select>
        </span>);
      }

      if (operatorEle && operatorEle.valueCount == 2) {
        rowContent.push(<span className="BatchModify-MiddleText">{operatorEle.middleText}</span>);
        rowContent.push(<span className={inputClassName} >
          <Select value={ele.value2}
            onChange={(value) => this.editFilterShowField("value2", index, value)}
            allowClear
            placeholder="请输入"
          // mode="tags"
          >
            {this.getValueOption(ele.fieldName)}
          </Select>
        </span>);
      }


      rowContent.push(<span>
        <div className='BatchModify-JiaJian'>
          <Button onClick={() => self.editFilterShowField("+", index)} size={'small'}><Icon type='tianjiashuliang' /></Button>
          <Button onClick={() => self.editFilterShowField("-", index)} size={'small'}><Icon type='jianshaoshuliang' /></Button>
        </div>
      </span>);

      contentArr.push(<div className='BatchModify-FilterRow' style={{ display: 'flex' }} >{rowContent}</div>);
    });
    return <div className='BatchModify-Filters' style={{ display: 'flex' }} >{contentArr}</div>;
  }

  editFilterShowField(field, index, value) {
    let filterObjs = this.state.filterObjs;
    let ele = filterObjs[index];
    if (field == "fieldName") {
      ele[field] = value;
      ele.value1 = "";
      ele.value2 = "";
    }
    else if (field == "operator") {
      ele[field] = value;
      ele.value1 = "";
      ele.value2 = "";
    }
    else if (field == "value1" || field == "value2") {
      ele[field] = value;
    }
    else if (field == "+") {
      let obj = this.getNullFilterObj();
      filterObjs.splice(index + 1, 0, obj)
    }
    else if (field == "-") {
      filterObjs.splice(index, 1)
    }
    this.setState({ filterObjs: filterObjs })
  }
  getNullFilterObj() {
    return { fieldName: "", operator: "", value1: "", value2: "" };
  }

  checkFilterRule(row, filter) {
    let fieldName = filter.fieldName;
    let ele = _.find(this.state.fieldInfoArr, function (o) { return o.fieldName == fieldName });
    let fieldValue = this.getFieldValue(row[fieldName]);
    let value1 = filter.value1;
    let value2 = filter.value2;

    if (fieldName == "" || filter.operator == "") {
      return true;
    }
    else if (filter.operator == "baohan") {
      return this.checkRule_baohan(fieldValue, value1, ele);
    }
    else if (filter.operator == "bubaohan") {
      return this.checkRule_bubaohan(fieldValue, value1, ele);
    }
    else if (filter.operator == "baohanyu") {
      return this.checkRule_baohanyu(fieldValue, value1, ele);
    }
    else if (filter.operator == "bubaohanyu") {
      return this.checkRule_bubaohanyu(fieldValue, value1, ele);
    }
    else if (filter.operator == "qujian") {
      return this.checkRule_qujian(fieldValue, value1, value2, ele);
    }
    else if (filter.operator == "dengyu") {
      return this.checkRule_dengyu(fieldValue, value1, ele);
    }
    else if (filter.operator == "budengyu") {
      return this.checkRule_budengyu(fieldValue, value1, ele);
    }
    else if (filter.operator == "xiaoyu") {
      return this.checkRule_xiaoyu(fieldValue, value1, ele);
    }
    else if (filter.operator == "xiaoyudengyu") {
      return this.checkRule_xiaoyudengyu(fieldValue, value1, ele);
    }
    else if (filter.operator == "dayu") {
      return this.checkRule_dayu(fieldValue, value1, ele);
    }
    else if (filter.operator == "dayudengyu") {
      return this.checkRule_dayudengyu(fieldValue, value1, ele);
    }

    else {
      this.consoleLog("batchModify 尚不支持当前操作符。filter = " + JSON.stringify(filter), true);
      return true;
    }
    return true;
  }
  checkRule_bubaohan(fieldValue, value1, ele) {
    return !this.checkRule_baohan(fieldValue, value1, ele);
  }
  checkRule_baohan(fieldValue, value1, ele) {
    if (this.isEmptyValue(fieldValue))
      fieldValue = "";
    if (this.isEmptyValue(value1))
      value1 = "";
    return fieldValue.toString().indexOf(value1.toString()) > -1;
  }

  checkRule_bubaohanyu(fieldValue, value1, ele) {
    return !this.checkRule_baohanyu(fieldValue, value1, ele);
  }
  checkRule_baohanyu(fieldValue, value1, ele) {
    if (this.isEmptyValue(fieldValue)) {
      fieldValue = "";
    }
    if (this.isEmptyValue(value1)) {
      value1 = "";
    }
    if (Array.isArray(value1)) {
      return value1.indexOf(fieldValue) >= 0;
    }
    else {
      return value1.toString().indexOf(fieldValue.toString()) > -1;
    }
  }

  checkRule_qujian(fieldValue, value1, value2, ele) {
    return this.checkRule_dengyu(fieldValue, value1, ele) ||
      this.checkRule_dengyu(fieldValue, value2, ele) ||
      (this.checkRule_dayu(fieldValue, value1, ele) && this.checkRule_xiaoyu(fieldValue, value2, ele));
  }

  checkRule_budengyu(fieldValue, value1, ele) {
    return !this.checkRule_dengyu(fieldValue, value1, ele);
  }
  checkRule_dengyu(fieldValue, value1, ele) {
    if (ele.dataType == "number") {
      // if (this.isEmptyValue(fieldValue)) {
      //   if (value1.length == 0)
      //     return true;
      //   else
      //     return false;
      // }
      // else {
      //   if (this.isEmptyValue(value1) || isNaN(value1)) {
      //     return false;
      //   }
      //   else {
      //     if (fieldValue == this.parseToFloat(value1))
      //       return true
      //     else
      //       return false;
      //   }
      // }
      if (this.isEmptyValue(fieldValue)) {
        fieldValue = 0;
      }
      if (this.isEmptyValue(value1) || isNaN(value1)) {
        value1 = 0;
      }
      return this.parseToFloat(fieldValue) == this.parseToFloat(value1);
    }
    else {
      return fieldValue.toString() == value1.toString();
    }
    return true;
  }
  checkRule_xiaoyudengyu(fieldValue, value1, ele) {
    return checkRule_xiaoyu(fieldValue, value1, ele) || checkRule_dengyu(fieldValue, value1, ele);
  }

  checkRule_xiaoyu(fieldValue, value1, ele) {

    if (ele.dataType == "number") {
      if (this.isEmptyValue(fieldValue)) {
        fieldValue = 0;
      }
      if (this.isEmptyValue(value1) || isNaN(value1)) {
        value1 = 0;
      }
      return this.parseToFloat(fieldValue) < this.parseToFloat(value1);
    }
    else {
      return fieldValue.toString() < value1.toString();
    }
  }

  checkRule_dayu(fieldValue, value1, ele) {
    if (ele.dataType == "number") {
      if (this.isEmptyValue(fieldValue)) {
        fieldValue = 0;
      }
      if (this.isEmptyValue(value1) || isNaN(value1)) {
        value1 = 0;
      }
      return this.parseToFloat(fieldValue) > this.parseToFloat(value1);
    }
    else {
      return fieldValue.toString() > value1.toString();
    }
  }
  checkRule_dayudengyu(fieldValue, value1, ele) {
    return checkRule_dayu(fieldValue, value1, ele) || checkRule_dengyu(fieldValue, value1, ele);
  }
  isEmptyValue(fieldValue) {
    if (fieldValue == undefined
      || fieldValue == null
      || fieldValue == ""
      // || (isNaN(fieldValue) == true && fieldValue.trim() == "")
      || (fieldValue.trim && fieldValue.trim() == "")
      || fieldValue.length == "")
      return true;
    else
      return false;
  }

  getUserFilteredRows() {
    let filterObjs = this.state.filterObjs;
    let gridDataRows = this.state.gridDataRows;
    this.consoleLog("当前录入的过滤的字段信息 filterObjs：" + JSON.stringify(filterObjs))
    gridDataRows.forEach((row) => {
      row.bCanBatchModify = true;
    });
    if (this.state.filterRange == 0) {
      gridDataRows.forEach((row) => {
        if (row.bCanBatchModify == true) {
          for (var k = 0; k < filterObjs.length; k++) {
            let filter = filterObjs[k];
            let bOK = this.checkFilterRule(row, filter);
            if (bOK == false) {
              row.bCanBatchModify = false;
              k = filterObjs.length;
            }
          }
        }
      });
    }

    let arr = [];
    gridDataRows.forEach((row, index) => {
      if (row.bCanBatchModify == true)
        arr.push(index)
    });
    return arr;
  }
  initDataByGrid() {
    let gridColumns = _.cloneDeep(this.gridModel && this.gridModel.getColumns());
    _.sortBy(gridColumns, function (o) { return o.iOrder; });
    let fieldInfoArr = [];
    let fieldModels = {};
    if (gridColumns) {
      Object.keys(gridColumns).forEach((key) => {
        let ele = gridColumns[key];
        ele.multiple = false;
        let fieldModel = this.getFieldModel(ele, ele.fieldName);
        let fieldInfo = {};
        fieldInfo.fieldName = ele.fieldName;
        fieldInfo.fieldCaption = ele.cShowCaption || ele.cCaption || "";
        fieldInfo.bCanModify = false;
        fieldInfo.bCanFilter = false;
        fieldInfo.UEType = 0;
        fieldInfo.ColumnEle = ele;
        fieldInfo.valueArr = [];
        fieldInfo.model = fieldModel;
        fieldInfo.dataType = "";// string number datetime
        if (ele && ele.bCanModify && !ele.bHidden) {
          this.setUETypeAndDataType(fieldInfo);
          if (isNaN(fieldInfo.UEType) == false && fieldInfo.UEType > 0) {
            fieldInfo.bCanModify = true;
          }
        }
        if (ele && !ele.bHidden) {
          fieldInfo.bCanFilter = true;
        }
        fieldModels[ele.fieldName] = fieldModel;
        fieldInfoArr.push(fieldInfo);
      });
    }
    else {
      this.consoleLog("批改错误：this.gridModel.getColumns()为空!", true);
    }
    let containerModel = new cb.models.ContainerModel();
    containerModel.setParent(this.gridModel);
    containerModel.setData(fieldModels);
    //参照列表展开前给扩展脚本处理
    this.model && this.model.execute('batchModifyReferProcess', containerModel);
    // 扩展脚本里加上如下内容
    // viewmodel.on("batchModifyReferProcess", function (vm) {
    //   debugger;
    //   //vendorextends!department_name
    //   // batchModify中初始化后，
    //   // viewmodel.execute('batchModifyInit', vm)，
    //   // 对应的扩展脚本中订阅这个事件，逻辑中写上vm.get('refer').on('afterBrowse', function(){vm.get('refer').getCache('vm').get('tree').on('beforeSetDataSource', function(args){}});
    //   let tmpVM = vm.get("vendorextends!department_name");
    //   if (tmpVM) {
    //     tmpVM.on('afterBrowse',
    //       function () {
    //         // tmpVM.get("propertyNames")
    //         let tmpVM2 = tmpVM.getCache('vm').get('tree');
    //         debugger;
    //         tmpVM2 && tmpVM2.on('beforeSetDataSource', function (args) {
    //           debugger;
    //         })
    //       }
    //     )
    //   }
    // });

    this.containerModel = containerModel;

    let gridDataRows = _.cloneDeep(this.gridModel.getShowRows());
    gridDataRows && gridDataRows.forEach((row, rowIndex) => {
      Object.keys(row).forEach((field, fieldIndex) => {
        let fieldEle = _.find(fieldInfoArr, function (o) { return o.fieldName == field });
        if (fieldEle && (fieldEle.bCanFilter || fieldEle.bCanModify)) {

          let fieldValue = this.getFieldValue(row[field]);
          if (this.isEmptyValue(fieldValue) == false) {
            if (!fieldEle.dataType) {
              fieldEle.dataType = this.getTypeOf(fieldValue);
            }
            if (_.filter(fieldEle.valueArr, function (o) { return o == fieldValue.toString() }).length == 0) {
              fieldEle.valueArr.push(fieldValue.toString());
            }
          }
        }
      });
    });

    fieldInfoArr && fieldInfoArr.forEach((ele, index) => {
      if (ele.valueArr.length == 0 || this.isEmptyValue(ele.fieldCaption)) {
        ele.bCanFilter = false;
      }
      else {
        ele.valueArr = _.orderBy(ele.valueArr);
      }
    });
    this.model && this.model.execute('batchModifySetFields', fieldInfoArr);

    // _.filter(fieldInfoArr ,function(o) {return _.get(o,"ColumnEle.cControlType")=="composite" })
    this.setState({
      fieldInfoArr,
      gridDataRows
    });
  }
  getFieldValue(value) {
    if (this.isEmptyValue(value))
      return value;
    else if (typeof (value) == "object")
      return value.text;
    else
      return value;
  }
  getTypeOf(fieldValue) {
    return typeof (fieldValue);
    // isNaN(data)&&!isNaN(Date.parse(data))
  }
  setUETypeAndDataType(fieldInfo) {
    // 1 数值类型  2 字符串类型  3 参照或者枚举类型 4 参照
    let ele = fieldInfo.ColumnEle;
    let cControlType = ele.cControlType.toLowerCase();
    let arr1 = ["inputnumber", "inputfloat", "money", "price", "money", "number", "float"];
    let arr2 = ["input"];
    let arr21 = ["compositeXX"];
    let arr4 = ["refer", "treerefer", "listrefer", "datepicker"];
    let arr41 = ["checkboxenum"];
    if (arr1.indexOf(cControlType) >= 0) {
      fieldInfo.UEType = 1;
      fieldInfo.dataType = "number";
    }
    else if (arr2.indexOf(cControlType) >= 0) {
      fieldInfo.UEType = 2;
    }
    else if (arr21.indexOf(cControlType) >= 0) {
      fieldInfo.UEType = 2;
    }
    else if (arr4.indexOf(cControlType) >= 0) {
      fieldInfo.UEType = 4;
      if (cControlType == "datepicker") {
        fieldInfo.dataType = "datetime";
      }
    }
    else if (arr41.indexOf(cControlType) >= 0) {
      fieldInfo.UEType = 4;
    }
    else if (ele.bEnum) {
      fieldInfo.UEType = 3;
    }
    else {
      fieldInfo.UEType = "没有获取正确的UEType";
      this.consoleLog("batchModify setUETypeAndDataType Err.批改没有获取正确的字段类型 --》cControlType = " + cControlType + " ele =  " + JSON.stringify(ele), true);
    }

  }
  consoleLog(str, bError) {
    if (bError)
      console.log(str);
  }
  getValueOption(fieldName) {
    let tmpArr = []
    if (!!fieldName) {
      let ele = this.getFieldEle(fieldName);
      ele.valueArr && ele.valueArr.forEach((caption) => {
        tmpArr.push(<Select.Option value={caption}>{caption}</Select.Option>);
      });
    }
    return tmpArr;
  }
  setStateNumberValue(name, value, bCheckNumber) {
    let bOK = true;
    value = value.trim();
    if (bCheckNumber == true && value != "") {
      if (isNaN(value) == true) {
        bOK = false;
      }
    }
    if (bOK) {
      this.state[name] = value;
      this.setState();
    }
  }
  setStateValue(tmpState) {
    this.setState(tmpState);
  }
  // filterOption(input, option) {
  //   return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  // }
  getRenderContent() {
    let arr = [];
    if (this.isList()) {
      arr.push(
        <div className='BatchModify-Range' >
          {/* <i className="anticon anticon-star"></i> */}
          <span>
            <Icon type='star' />
            批改范围
            </span>
          <Radio.Group
            value={this.state.filterRange}
            onChange={e => this.setStateValue({ "filterRange": e.target.value })}
          >
            <Radio value={0}>仅选中记录</Radio>
            <Radio value={1}>所有查询记录</Radio>
          </Radio.Group>
        </div >
      );
    }
    if (this.isVoucher() || this.isTest()) {
      arr.push(
        <div className='BatchModify-Range'>
          <span>
            <Icon type='star' />
            批改范围
       </span>
          <Radio.Group
            value={this.state.filterRange}
            onChange={e => this.setStateValue({ "filterRange": e.target.value })}
          >
            <Radio value={1}>全部</Radio>
            <Radio value={0}>按条件</Radio>
          </Radio.Group>
        </div >
      );
      if (this.state.filterRange == 0) {
        arr.push(this.getFilterShowContent());
      }
    }
    let modifyRender = [];
    this.state.fieldInfoArr.forEach((ele, index) => {
      if (ele.bCanModify) {
        modifyRender.push(<Select.Option value={ele.fieldName}>{ele.fieldCaption}</Select.Option>);
      }
    });
    arr.push(<div className='BatchModify-ModifyField' >
      <span>修改项</span>
      <span>
        <Select
          showSearch={true}
          value={this.state.modifyFieldName}
          onChange={(fieldName) => this.fieldChanged(fieldName)}
          // filterOption={this.filterOption}
          optionFilterProp="children"
        >
          {modifyRender}
        </Select>
      </span>
    </div >);
    let control = <div key={"BatchModifyId_" + this.state.modifyFieldName} >{this.getReferControl()}</div>;
    if (this.state.UEType == 1) {
      arr.push(<div className='BatchModify-Operator'>
        <span>运算符</span>
        <span>
          <Select value={this.state.modifyOperator}
            onChange={(value) => this.setStateValue({ "modifyOperator": value })}>
            <Select.Option value={"="} >{"="}</Select.Option>
            <Select.Option value={"+"}>{"+"}</Select.Option>
            <Select.Option value={"-"} >{"-"}</Select.Option>
            <Select.Option value={"*"} >{"*"}</Select.Option>
            <Select.Option value={"/"} >{"/"}</Select.Option>
          </Select>
        </span>
      </div >);
      arr.push(<div className='BatchModify-ModifyValue'>
        <span>数值</span>
        <span>
          {control}
          {/* <Input
            placeholder="请输入"
            value={this.state.mFieldValue}
            onChange={(e) => this.setStateNumberValue("mFieldValue", e.target.value, true)}
          /> */}
        </span>
      </div >);
    }
    else if (this.state.UEType == 2) {//文本
      arr.push(<div className='BatchModify-ModifyTo'>
        <span>修改为</span>
        <span>
          {control}
          {/* <Input
            placeholder="请输入"
            value={this.state.mFieldValue}
            onChange={(e) => this.setStateValue({ "mFieldValue": e.target.value })}
          /> */}
        </span>
      </div >);
    }
    else if (this.state.UEType == 3) {// 枚举
      let control2 = <div key={"BatchModifyId_" + this.state.modifyFieldName} >{this.getEnumControl()}</div>;
      arr.push(<div className='BatchModify-ModifyTo'>
        <span>修改为</span>
        <span>
          {control2}
        </span>
      </div >);
    }
    else if (this.state.UEType == 4) {//参照
      arr.push(<div className='BatchModify-ModifyTo'>
        <span>修改为</span>
        <span>
          {control}
        </span>
      </div >);
    }
    return arr;
  }

  getFieldEle(fieldName) {
    fieldName = fieldName || this.state.modifyFieldName;
    return _.find(this.state.fieldInfoArr, function (o) { return o.fieldName == fieldName });
  }
  fieldChanged(fieldName) {
    //可能因为UEType不同，或者小数精度不同，需要清空部分界面字段
    let ele = this.getFieldEle(fieldName);
    this.containerModel.clear(false);
    this.containerModel.setDirty(false);
    if (ele) {
      this.setStateValue({ "modifyFieldName": ele.fieldName, "UEType": ele.UEType });//, "mFieldValue": ""
    }
    this.consoleLog("当前批量修改的字段ele：" + JSON.stringify(ele))
  }
  clearNullObj(obj) {
    obj && Object.keys(obj).forEach((key) => {
      if (obj[key] === null || obj[key] === undefined)
        delete obj[key];
    });
    return obj;
  }

  isVoucher() {
    return this.billType == "voucher";
  }
  isList() {
    return this.billType == "list";
  }

  getNecessaryDataForRows(modifyFieldName) {
    let selRows = this.gridModel.getSelectedRows();
    let tmpData = this.gridModel.getNecessaryDataForRows(selRows)
    selRows.forEach(function (row, index) {
      if (row.id) {
        // Object.assign(tmpData[index], {
        //   id: row.id
        // })
        tmpData[index].id = row.id;
        tmpData[index][modifyFieldName] = row[modifyFieldName];
      }
    }, this);
    return tmpData;
  }
  isNumber(value) {
    return !(this.isEmptyValue(value) || this.isEmptyValue(value.toString()) || isNaN(value.toString()))
  }
  calcuteValue(ele, value1, value2, operator) {
    let iNumPoint = ele.hasOwnProperty(iNumPoint) ? ele.iNumPoint : -1;
    let resultValue = undefined;
    if (operator == "+") {
      if (this.isNumber(value1) == false)
        resultValue = value2;
      else if (this.isNumber(value2) == false)
        resultValue = value1;
      else
        resultValue = this.parseToFloat(value1) + this.parseToFloat(value2);
    }
    else if (operator == "-") {
      if (this.isNumber(value1) == false)
        resultValue = 0 - this.parseToFloat(value2);
      else if (this.isNumber(value2) == false)
        resultValue = value1;
      else
        resultValue = this.parseToFloat(value1) - this.parseToFloat(value2);
    }
    else if (operator == "*") {
      if (this.isNumber(value1) == false)
        resultValue = value1;
      else if (this.isNumber(value2) == false)
        resultValue = value1;
      else
        resultValue = this.parseToFloat(value1) * this.parseToFloat(value2);
    }
    else if (operator == "/") {
      if (this.isNumber(value1) == false)
        resultValue = value1;
      else if (this.isNumber(value2) == false)
        resultValue = value1;
      else
        resultValue = this.parseToFloat(value1) / this.parseToFloat(value2);
    }
    else if (operator == "=") {
      resultValue = value2;
    }
    if (iNumPoint >= 0) {
      resultValue = this.parseToFloat(resultValue.toFixed(iNumPoint));
    }
    return resultValue;
  }
  handleOk(e) {
    let self = this;
    let obj = this.getModifiedArr();
    if (this.validateInput(obj) == true) {
      // let obj = this.containerModel && this.containerModel.collectData();
      let modifyFieldName = self.state.modifyFieldName;
      let modifyFieldValue = "";
      if (modifyFieldName != "") {
        let ele = this.getFieldEle(modifyFieldName);
        modifyFieldValue = obj[modifyFieldName];
        if (this.isList() == true) {
          let params = {
            billnum: this.billNo
          };
          if (this.state.filterRange == 0) {
            let necessaryRows = this.getNecessaryDataForRows(modifyFieldName);
            if (this.state.UEType == 1) {
              params.externalData = {}
              params.externalData[modifyFieldName] = modifyFieldValue;
            }
            else {
              let obj2=_.cloneDeep(obj);
              for (var i in obj2) {
                obj2[i] = "'" + obj2[i] + "'";
              }
              params.externalData = obj2;
            }
            necessaryRows.forEach((row) => {
              if (this.state.UEType == 1) {
                row[modifyFieldName] = this.calcuteValue(ele, row[modifyFieldName], modifyFieldValue, this.state.modifyOperator);
              }
              else {
                Object.assign(row, obj);
              }
            });
            params.data = JSON.stringify(necessaryRows);
          }
          else {
            if (this.state.UEType == 1) {
              if (this.state.modifyOperator == "+") {
                modifyFieldValue = ele.ColumnEle.cFieldName + "+" + modifyFieldValue;
              }
              else if (this.state.modifyOperator == "-") {
                modifyFieldValue = ele.ColumnEle.cFieldName + "-" + modifyFieldValue;
              }
              else if (this.state.modifyOperator == "*") {
                modifyFieldValue = ele.ColumnEle.cFieldName + "*" + modifyFieldValue;
              }
              else if (this.state.modifyOperator == "/") {
                modifyFieldValue = ele.ColumnEle.cFieldName + "/" + modifyFieldValue;
              }
              params.externalData = {}
              params.externalData[modifyFieldName] = modifyFieldValue;
            }
            else {
              for (var i in obj) {
                obj[i] = "'" + obj[i] + "'";
              }
              params.externalData = obj;
            }
            let condition = this.model.getCache('lastSearchCondition');
            params.condition = condition && condition.condition;
          }
          if (params.condition || params.data) {
            let callback = (json) => {
              this.model.execute('refresh');
              if (json.code === 200) {
                cb.utils.alert('更新成功。', 'success');
                self.handleCancel();
              }
              else {
                cb.utils.alert("更新失败！返回信息：" + (json.message ? json.message : JSON.stringify(json)), 'warning');
              }
            }
            this.consoleLog("列表批改 调用批改列表服务  参数 /bill/batchModify ----->" + JSON.stringify(params));
            try {
              let cParameterStr = self.props.params && self.props.params.cParameter;
              if (cParameterStr) {
                let cParameter = JSON.parse(cParameterStr);
                if (cParameter && cParameter.extendParams) {
                  params = Object.assign({}, params, cParameter.extendParams);
                }
              }
            }
            catch (e) {

            }
            eChartProxy.doProxy("/bill/batchModify", 'POST', params, callback);
          }
          else {
            cb.utils.alert('获取过滤条件错误。', 'warning');
          }
        }
        else if (this.isVoucher() == true) {
          let modifyRowIndex = self.getUserFilteredRows();
          this.consoleLog("单据批改 符合条件行信息 ----->" + JSON.stringify(modifyRowIndex));
          let controlType = ele.ColumnEle.cControlType.toLowerCase();
          if (modifyRowIndex.length > 0) {
            modifyRowIndex.forEach((i) => {
              // i = ele;
              if (controlType === 'refer' || controlType === 'treerefer' || controlType === 'listrefer') {
                let curModel = ele.model;
                let args = { value: curModel.getSelectedNodes() };
                let bill2ReferKeyFieldMap = curModel._get_data('bill2ReferKeyFieldMap');
                let checkValid = curModel._get_data('checkValid');
                let returnText = curModel._get_data('returnText');
                this.consoleLog("单据批改 row=" + i
                  + " modifyFieldName = " + modifyFieldName
                  + " args = " + JSON.stringify(args)
                  + " bill2ReferKeyFieldMap = " + JSON.stringify(bill2ReferKeyFieldMap)
                  + " checkValid = " + JSON.stringify(checkValid)
                  + " returnText = " + JSON.stringify(returnText));

                self.gridModel.referValueChange2(
                  i,
                  modifyFieldName,
                  args,
                  bill2ReferKeyFieldMap,
                  checkValid,
                  returnText
                );
              }
              else {
                let modifyFieldValue2 = modifyFieldValue;
                if (this.state.UEType == 1) {
                  let oldValue = this.parseToFloat(self.gridModel.getCellValue(i, modifyFieldName));
                  modifyFieldValue2 = this.parseToFloat(modifyFieldValue2);
                  if (this.state.modifyOperator == "=") {
                    modifyFieldValue2 = modifyFieldValue2;
                  }
                  else if (this.state.modifyOperator == "+") {
                    modifyFieldValue2 = oldValue + modifyFieldValue2;
                  }
                  else if (this.state.modifyOperator == "-") {
                    modifyFieldValue2 = oldValue - modifyFieldValue2;
                  }
                  else if (this.state.modifyOperator == "*") {
                    modifyFieldValue2 = oldValue * modifyFieldValue2;
                  }
                  else if (this.state.modifyOperator == "/") {
                    modifyFieldValue2 = oldValue / modifyFieldValue2;
                  }
                }
                this.consoleLog("单据批改 row=" + i + " modifyFieldName = " + modifyFieldName + " modifyFieldValue = " + modifyFieldValue2)
                self.gridModel.setCellValue(i, modifyFieldName, modifyFieldValue2, true, true)
              }
            })
            self.handleCancel();
          }
          else {
            cb.utils.alert('没有符合条件的行记录', 'warning')
          }
        }
      }
      else {
        cb.utils.alert("请选择字段" + json.message, 'warning');
      }
    }
  }
  parseToFloat(value) {
    if (this.isEmptyValue(value))
      return 0;
    else
      return parseFloat(value);
  }
  beforeAct(params, callBack) {
    callBack();
  }
  afterAct(params, callBack) {
    callBack();
  }
  handleCancel(e) {
    if (this.props.close)
      this.props.close();
  }
  render() {
    let arr = this.getRenderContent();;

    let billType = this.billType;
    return <Modal
      title="批改"
      width={800}
      height={500}
      visible={true}
      // footer={null}
      onOk={(e) => this.handleOk(e)}
      onCancel={(e) => this.handleCancel(e)}
      className={'BatchModify-Modal-' + billType}
    >
      <div className={'BatchModify-Content' + billType} >
        {arr}
      </div>
    </Modal>;
  }
  getEnumControl() {
    let ele = this.getFieldEle();
    ele.ColumnEle.cControlType = "radio";
    return this.getReferControl(ele);

    // let columnEle = ele && ele.ColumnEle;
    // // this.fieldModel = this.getFieldModel(columnEle, ele.fieldName);
    // let control = (
    //   <Row key={columnEle.itemName}>
    //     <Col  >
    //       <Tag2
    //         TagTitle={""}
    //         TagData={columnEle.enumString}
    //         // TagCanMultSel={columnEle.multSelect == 0 ? false : true}
    //         TagCanMultSel={false}
    //         TagClicked={this.TagClicked}
    //         model={ele.model}
    //       />
    //     </Col>
    //   </Row>
    // );
    // return control;
  }
  getReferControl(ele) {
    ele = ele || this.getFieldEle();
    // this.consoleLog("当前批量修改的字段ele：" + JSON.stringify(ele))
    let columnEle = ele && ele.ColumnEle;
    if (columnEle) {
      let ctrlType;
      if (columnEle.cControlType)
        ctrlType = columnEle.cControlType.trim().toLocaleLowerCase();
      else
        ctrlType = "input";
      const ComName = BasicComponentsMap[ctrlType];
      // this.fieldModel = this.getFieldModel(columnEle, ele.fieldName);
      // this.fieldModel.on('beforeValueChange', this.beforeValueChange);
      // this.fieldModel.on('beforeBrowse', this.beforeBrowse);
      // this.fieldModel.on('afterValueChange', this.afterValueChange);
      let config = null;
      try {
        config = JSON.parse(columnEle.extendField);
      } catch (e) {
        config = {};
      }
      if (ele.UEType == 4) {
        this.model && this.model.execute('batchModifyReferSet', ele.model, ele.ColumnEle);
      }
      return ComName ? <ComName
        model={ele.model}
        title={ele.fieldCaption}
        {...config} /> :
        <h1>{ctrlType}</h1>;

    }
  }
  getFieldModel(column, attr) {
    var controlType = column.cControlType && column.cControlType.trim().toLocaleLowerCase(), model;
    if (controlType === 'refer' || controlType === 'treerefer' || controlType === 'listrefer') {
      model = new cb.models.ReferModel(cb.utils.extend(true, {}, { multiple: column.bMustSelect ? true : false }, column));
    }
    else if (controlType === 'tag' || controlType === 'attachment' || controlType === 'checkboxgroup') {
      model = new cb.models.TagModel(cb.utils.extend(true, { needCollect: false }, column));
    }
    else if (controlType === 'select' || controlType === 'radio' || controlType === 'checkboxenum') {
      model = new cb.models.ListModel(cb.utils.extend(true, {}, column));
    }
    else if (controlType === 'table') {
      model = new cb.models.GridModel(cb.utils.extend(true, { needCollect: false }, column));
    }
    else if (controlType === 'cascader') {
      var bill2ReferKeyFieldMap = cb.utils.getBill2ReferKeyFieldMap(column.cRefRetId);
      var config = null;
      try {
        config = JSON.parse(column.cStyle);
      } catch (e) {
        config = {};
      }
      model = new cb.models.TreeModel({
        cControlType: controlType,
        keyField: config.keyField || 'id',
        titleField: config.titleField || 'name',
        childrenField: config.childrenField,
        parentField: config.parentField,
        mergeField: config.mergeField,
        dataSourceMode: 'remote'
      });
      model.setDataSource(config.proxy || { url: '/region/getAllregion', method: 'POST' });

    } else {
      model = new cb.models.SimpleModel(cb.utils.extend(true, {}, { invalidReset: false }, column));
    }
    return model;
  };

}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/batchModify.jsx